import $ from "jquery";
import { application } from "../application/application";
import { dataaccess } from "../dataaccess/dataContext";

function init() {
    $("[alertId]").click(deleteAlert);
    $(".alert").dblclick(goToAlertSubject);
}

function deleteAlert() {
    const alertId = $(this).attr("alertid");
    dataaccess.delete({ url: "/alerts/" + alertId }).done(function() {
        $("[alertid=" + alertId + "]").each(function(idx, item) {
            $(item).closest("div").remove();
        });
    });
}

function goToAlertSubject() {
    const href = $(this).attr("href");
    window.location.href = application.baseUrl + href;
}

export const alerts = {
    init: init
};